import React from 'react'
import EditVisaPackageWorker from './edit'
import { Link, withRouter } from 'react-router-dom'
import VisaPackageForm from '../components/form/form.component'
import FormHelper from '../../../../utils/FormHelper'
import './edit.styles.scss'
import Dialog from '../../../../components/dialog/dialog.component'
import Loading from '../../../../components/loading/loading.component'

class EditVisaPackage extends React.Component {

    constructor(props) {
        super(props)
        this.editVisaPackageWorker = EditVisaPackageWorker(this)
        this.state = this.editVisaPackageWorker.getDefaultState()
    }

    componentDidMount() {
        this.editVisaPackageWorker.loadVisaPackage()
    }

    onSubmit = (e) => {
        e.preventDefault()
        this.editVisaPackageWorker.isValid() && this.editVisaPackageWorker.updateVisaPackage()
    }

    onCancel = () => this.props.history.push('/content/visa-packages')

    render() {
        return (
            <div className="edit-visa-package">
                {
                    (this.state.loadingVisaPackage || this.state.updatingVisaPackage) && <Dialog><Loading /></Dialog>
                }
                <div className="card">
                    <Link className="btn" to="/content/visa-packages">Visa Packages</Link>
                    <div className="header">
                        <h4>Edit Visa Package</h4>
                    </div>
                    <div className={"flag " + this.state.flag.type}>
                        {this.state.flag.text}
                    </div>
                    <VisaPackageForm {...this.state} action="Save Visa Package" onChange={FormHelper(this).onChange} onSubmit={this.onSubmit} onCancel={this.onCancel} />
                </div>
            </div>
        )
    }
}

export default withRouter(EditVisaPackage)
